"use client";
import { jsx as b } from "react/jsx-runtime";
import { createContext as C, useContext as w, useState as c } from "react";
import { useBoolean as A } from "../hooks/use-boolean.js";
import { generateUid as B } from "../utils/generate-uid.js";
import { useChat as x } from "../components/embedded-chat/chat-provider.js";
const d = C(void 0);
function T() {
  const [t, s] = c(null), { value: p, setTrue: f, setFalse: l } = A(!1), [n, u] = c({ title: "", content: "" }), [v, m] = c({
    title: void 0,
    content: void 0
  }), { addAttachment: h } = x(), o = {
    data: n,
    errors: v,
    labels: {
      title: t?.workflowModalProps?.titleInputLabel || "Title",
      content: t?.contentType.contentInputLabel || "Content"
    },
    validate() {
      const e = {};
      return n.title.trim() || (e.title = `${o.labels.title} is required`), n.content.trim() || (e.content = `${o.labels.content} is required`), e;
    },
    onChange(e) {
      const { name: r, value: a } = e.target;
      u((i) => ({ ...i, [r]: a }));
    },
    onSubmit(e) {
      if (e.preventDefault(), !t?.contentType) return;
      const r = o.validate();
      if (Object.values(r).some((i) => !!i)) {
        m(r);
        return;
      }
      const a = {
        ...n,
        id: B(),
        contentType: t.contentType
      };
      h(a), l(), u({ title: "", content: "" }), m({ title: void 0, content: void 0 });
    }
  };
  return {
    selectedInput: t,
    selectInput: s,
    isOpen: p,
    onOpen: f,
    onClose: l,
    form: o
  };
}
function D({ children: t }) {
  const s = T();
  return /* @__PURE__ */ b(d.Provider, { value: s, children: t });
}
const O = () => {
  const t = w(d);
  if (!t)
    throw new Error("useAttachmentsBar must be used within a AttachmentsBarProvider");
  return t;
};
export {
  D as AttachmentsBarProvider,
  O as useAttachmentsBar
};
